import _ from "lodash";
import i18n from "../../../shared/i18n";
import {store} from "@/plugins/vuex";
import {VENDORS_TABLE_NAME} from "@/modules/constants";
import SettlementService from "@/modules/settlements/SettlementService";
import VendorsSearch from "@/modules/vendors/VendorsSearch.model";
import unsoldProposals from "./unsold-proposals"
import {hasPermission} from "@/core/directives/permission";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-no',
    search: '',
    searchModel: new VendorsSearch(),
    extraFilters: {},
    expand: '',
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      requiredFields: ['full_name'],
      defaultFields: [
        'no',
        'full_name',
        'financial_items',
        // 'total_lots_sold',
        // 'total_lots_unsold',
        // 'total_financial_items_released',
        'company_name',
        'email',
        'actions',
      ],
    }
  }
};

let getDefaultFields = () => {
  let fields =  [
    {
      key: "no",
      label: i18n.t('No'),
      sortable: true,
      tdClass: 'customer-no-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "full_name",
      label: i18n.t('Vendor'),
      sortable: true,
      tdClass: 'full-name-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "company_name",
      label: i18n.t('Company Name'),
      sortable: true,
      tdClass: 'company-name-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "email",
      label: i18n.t('Email'),
      sortable: true,
      tdClass: 'email-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "client_tier",
      label: i18n.t('Client Tier'),
      sortable: true,
      tdClass: 'client-tier-col',
      isVisible: true,
      expand: 'customer'
    },
    {
      key: "address",
      label: i18n.t('Billing Address'),
      sortable: true,
      tdClass: 'billing-address-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "financial_items",
      label: i18n.t('Lots'),
      sortable: true,
      tdClass: 'financial-items-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "total_lots_sold",
      label: i18n.t('Sold Lots'),
      sortable: true,
      tdClass: 'total-lots-sold-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "total_lots_unsold",
      label: i18n.t('Unsold Lots'),
      sortable: true,
      tdClass: 'total-lots-unsold-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "total_financial_items_released",
      label: i18n.t('Settled Lots'),
      sortable: true,
      tdClass: 'total-financial-items-released-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "actions",
      label: i18n.t('Actions'),
      sortable: false,
      tdClass: 'actions-col',
      isVisible: true,
      exclude_from_export: true,
      expand: 'customer.identification,customer.billing_address.country'
    },
    {
      key: 'identity_verification',
      label: i18n.t('Identity Verification'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'customer.term'
    },
  ]

  const excludeFields = [];
  if (!hasPermission('view_customeridentification')) {
    excludeFields.push('identity_verification');
  }
  if (excludeFields.length) {
    fields = fields.filter(f => !excludeFields.includes(f.key));
  }
  return fields
}


export default {
  namespaced: true,
  state: {
    tableSource: null,
    tableData: {
      sale: getDefaultTableData(),
    },
  },
  actions: {
    initTableData({state}) {
      state.tableData = {
        sale: getDefaultTableData(),
      }
      return true
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${VENDORS_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const defaultExpand = currentTableData.expand
      const expand = currentTableData.toggleColumns.fields
          .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
          .map(c => c.expand)
          .join(',')

      data.expand = `${expand},${defaultExpand}`;

      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await SettlementService.getSettlementVendorData(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    async updateTableSource({state}, {extraFilters, source, sale, customer = null}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
      state.tableData[source].sale = sale;
      state.tableData[source].customer = customer;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new VendorsSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = {
        ...state.tableData[state.tableSource],
        ...defaultTableData
      };
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
  },
  mutations: {
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {
      ...state.tableData[state.tableSource],
      ...payload
    },
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
  },
  modules: {
    unsoldProposals: unsoldProposals
  }
}
